import flow from 'lodash/flow';
const trimString = (s) => s.trim();
const lowerCaseString = (s) => s.toLowerCase();
const replaceDuplicateWhiteSpacesWithSingleSpace = (s) => s.replace(/\s+/g, ' ');
const replaceHyphenAndDashesWithHyphenMinus = (s) => s.replace(/–|—|—|−/g, '-');
const replaceSpacesWithCharacter = (ch) => (s) => s.replace(/ /g, ch);
const removeNonAlphaNumeric = ({ keepSpacesBetweenWords, charactersToKeep, }) => (s) => {
    const regex = new RegExp(`${`[^a-zA-Z0-9${keepSpacesBetweenWords ? ' ' : ''}${charactersToKeep ? charactersToKeep.map((c) => `\\${c}`).join('') : ''}]`}`, 'g');
    return s.replace(regex, '');
};
export const sanitizeString = ({ string, trim = false, alphaNumericOnly = false, removeDuplicateSpaces = false, toLowerCase = false, onlyHyphenMinus = false, replaceSpacesWith = undefined, }) => {
    const methods = [];
    if (toLowerCase) {
        methods.push(lowerCaseString);
    }
    if (onlyHyphenMinus) {
        methods.push(replaceHyphenAndDashesWithHyphenMinus);
    }
    if (alphaNumericOnly) {
        methods.push(removeNonAlphaNumeric({
            keepSpacesBetweenWords: alphaNumericOnly.keepSpacesBetweenWords,
            charactersToKeep: alphaNumericOnly.charactersToKeep,
        }));
    }
    if (trim) {
        methods.push(trimString);
    }
    if (removeDuplicateSpaces) {
        methods.push(replaceDuplicateWhiteSpacesWithSingleSpace);
    }
    if (replaceSpacesWith) {
        methods.push(replaceSpacesWithCharacter(replaceSpacesWith));
    }
    return flow(methods)(string);
};
//# sourceMappingURL=sanitizeString.js.map